import React from 'react';
import ProductLists from '../components/ProductLists';

const Products = () => {
  return (
    <>
      <ProductLists />
    </>
  );
};

export default Products;
